<div mat-dialog-content class="content">
  <i class="material-icons error-icon">error</i>
  <span>{{data.message}}</span>
</div>
<div mat-dialog-actions class="actions-container">
  <button mat-raised-button (click)="close()">close</button>
</div>
